import { FONTS, } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import { IMG_CDN_URL } from "constants/pathConstant";
import styled from "styled-components";

export const Wrapper = styled.section`
  width: 100%;
  height: 100%;
`;

export const Title = styled.div<{ $isKor: boolean }>`
  font-size: 6.4rem;
  text-align: center;
  display: flex;
  justify-content: center;

  & > p {
    font-family: ${FONTS.H};
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 6rem;
    font-size: 2.4rem;
    display: ${(props) => (props.$isKor ? "flex" : "block")};
    line-height: ${(props) => (props.$isKor ? "" : "1.5rem")};
  }
`;

export const Background = styled.div<IStyle>`
  width: 100%;
  height: 85rem;
  margin-top: 4rem;
  background: url(${IMG_CDN_URL}/file/387ff74abg1-min.webp) no-repeat;
  background-size: contain;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: start;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    height: 25rem;
    background: url(${IMG_CDN_URL}/file/06608b70bg1_phone-min.webp) no-repeat;
    background-size: contain;
    margin-top: ${(props) => (props.lang ? "12.2rem" : "12.2rem")};
  }

  & > div {
    margin: 7.8rem 3.6rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      display: none;
    }
  }
`;

export const TextBoxPhone = styled.div`
  display: none;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* position: absolute; */
    margin: 3rem 1.5rem -10rem;
    gap: 2rem;

    & > p {
      letter-spacing: 0.1rem;
      padding: 3rem;
      background: rgba(255, 255, 255, 0.5);
      border: 2.4rem;
      border-radius: 2.4rem;
      font-size: 1.4rem;
      line-height: 2rem;
    }

    & > div {
      font-size: 1.4rem;
      font-family: ${FONTS.B};
      background: #B1E5E2;
      color: #000;
      padding: 1rem 1.8rem;
      border-radius: 10rem;
      cursor: pointer;
    }
  }
`;

export const TextBox = styled.div<IStyle>`
  width: 58rem;
  padding: 6.7rem;
  background: rgba(0, 0, 0, 0.5);
  border: 2.4rem;
  border-radius: 2.4rem;
  font-size: 2.4rem;
  line-height: ${(props) => (props.lang ? 1.05 : 1.25)};
`;

export const DownloadBtn = styled.div`
  margin-top: 3rem;
  padding: 1.5rem 4rem;
  background: #B1E5E2;
  border-radius: 10rem;
  color: #000;
  font-size: 2.4rem;
  text-align: center;
  cursor: pointer;
  font-family: ${FONTS.B};
`;

interface IStyle {
  lang: boolean;
}
